import {
  ProductPagesInsuranceFeesDocument,
  ProductPagesInsuranceFeesQuery,
} from "app/smartphone/[slug]/[reference]/product-pages-insurance-fees.query.generated";
import { formatToCurrency } from "utils/price.utils";
import { initializeApollo } from "utils/with-apollo.utils";

export const getInsuranceFees = async (subscriptionModelName?: string) => {
  try {
    const apolloClient = initializeApollo();

    const { data: insuranceFeesData } =
      await apolloClient.query<ProductPagesInsuranceFeesQuery>({
        query: ProductPagesInsuranceFeesDocument,
        variables: { deviceModel: subscriptionModelName },
      });

    const insuranceFees = insuranceFeesData?.insuranceFees;
    const breakageFeePrice = formatToCurrency(
      "fr-FR",
      "EUR",
      insuranceFees?.breakageFee || 0,
    );
    const theftFeePrice = formatToCurrency(
      "fr-FR",
      "EUR",
      insuranceFees?.theftFee || 0,
    );

    return { breakageFeePrice, theftFeePrice };
  } catch (_) {
    return { breakageFeePrice: null, theftFeePrice: null };
  }
};
